import { Target, Users, Brain, BarChart3, Activity, UserCheck, MessageSquare, Shield, Bot, BookOpen, FileText, MessageCircle, Utensils } from "lucide-react";

// Updated menu order — short single-line labels for horizontal nav
const getMenuItems = (userRole) => {
  const baseMenu = [
    { icon: Target, label: "Goals", path: "/goals" },
    { icon: FileText, label: "Training Plan", path: "/plans" },
    { icon: Brain, label: "Training", path: "/training" },
    { icon: BookOpen, label: "Journal", path: "/journal" },
    { icon: Utensils, label: "Nutrition & Exercise", path: "/daily-log" },
    { icon: Bot, label: "AI Coach", path: "/ai-coach" },
    { icon: MessageCircle, label: "Messages", path: "/messages" },
    { icon: Activity, label: "Wellness", path: "/wellness-trends" }
  ];
  
  // Add Team Reports for coaches and higher permissions
  if (userRole && ['coach', 'team-admin', 'system-admin', 'sport-performance-consultant', 'school-admin'].includes(userRole)) {
    baseMenu.splice(8, 0, { icon: BarChart3, label: "Team Reports", path: "/team-reports" });
  }
  
  // Add Athlete Overview for coaches and higher permissions
  if (userRole && ['coach', 'team-admin', 'system-admin', 'sport-performance-consultant', 'school-admin'].includes(userRole)) {
    baseMenu.splice(9, 0, { icon: UserCheck, label: "Athletes", path: "/athlete-overview" });
  }
  
  // Add User Management for administrators
  if (userRole && ['system-admin', 'school-admin', 'team-admin'].includes(userRole)) {
    baseMenu.push({ icon: Shield, label: "Users", path: "/user-management" });
  }
  
  return baseMenu;
};

export { getMenuItems };
export const menuItems = getMenuItems();
